import _implicitStylesheets from "./locationFilter.css";
import _implicitScopedStylesheets from "./locationFilter.scoped.css?scoped=true";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<label${"a0:for"} class="label${0}"${2}>${"t1"}</label>`;
const $fragment2 = parseFragment`<option selected${"a0:value"}${3}>${"t1"}</option>`;
const $fragment3 = parseFragment`<option${"a0:value"}${3}>${"t1"}</option>`;
const $fragment4 = parseFragment`<option disabled${"a0:value"}${3}>${"t1"}</option>`;
const $fragment5 = parseFragment`<label${"a0:for"} class="label${0}"${2}>${"t1"}</label>`;
const $fragment6 = parseFragment`<option selected${"a0:value"}${3}>${"t1"}</option>`;
const $fragment7 = parseFragment`<option${"a0:value"}${3}>${"t1"}</option>`;
const stc0 = {
  props: {
    "type": "filter"
  },
  key: 0
};
const stc1 = {
  key: 1
};
const stc2 = {
  classMap: {
    "select-container": true
  },
  key: 4
};
const stc3 = {
  "aria-label": "country",
  "data-testid": "loc-country",
  "name": "country"
};
const stc4 = {
  key: 12
};
const stc5 = {
  classMap: {
    "select-container": true
  },
  key: 15
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, b: api_bind, k: api_key, i: api_iterator, h: api_element, c: api_custom_element} = $api;
  const {_m0, _m1} = $ctx;
  return [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, stc0, [api_element("div", stc1, [api_static_fragment($fragment1, 3, [api_static_part(0, {
    attrs: {
      "for": api_scoped_id("country")
    }
  }, null), api_static_part(1, null, " " + api_dynamic_text($cmp.labels.country) + " ")]), api_element("div", stc2, [api_element("select", {
    attrs: stc3,
    key: 5,
    on: {
      "change": _m0 || ($ctx._m0 = api_bind($cmp.countryChangeHandler))
    }
  }, api_iterator($cmp.countryOptions, function (option) {
    return [!option.disabled ? option.selected ? api_static_fragment($fragment2, api_key(7, option.key), [api_static_part(0, {
      attrs: {
        "value": option.value
      }
    }, null), api_static_part(1, null, api_dynamic_text(option.label))]) : null : null, !option.disabled ? !option.selected ? api_static_fragment($fragment3, api_key(9, option.key), [api_static_part(0, {
      attrs: {
        "value": option.value
      }
    }, null), api_static_part(1, null, api_dynamic_text(option.label))]) : null : null, option.disabled ? api_static_fragment($fragment4, api_key(11, option.key), [api_static_part(0, {
      attrs: {
        "value": option.value
      }
    }, null), api_static_part(1, null, api_dynamic_text(option.label))]) : null];
  }))])]), api_element("div", stc4, [api_static_fragment($fragment5, 14, [api_static_part(0, {
    attrs: {
      "for": api_scoped_id("state")
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.labels.states) + " ")]), api_element("div", stc5, [api_element("select", {
    attrs: {
      "data-testid": "loc-state",
      "aria-label": "state",
      "name": "state",
      "disabled": $cmp.stateDisabled ? "" : null
    },
    key: 16,
    on: {
      "change": _m1 || ($ctx._m1 = api_bind($cmp.stateChangeHandler))
    }
  }, api_iterator($cmp.stateOptions, function (option) {
    return [option.selected ? api_static_fragment($fragment6, api_key(18, option.key), [api_static_part(0, {
      attrs: {
        "value": option.value
      }
    }, null), api_static_part(1, null, api_dynamic_text(option.label))]) : null, !option.selected ? api_static_fragment($fragment7, api_key(20, option.key), [api_static_part(0, {
      attrs: {
        "value": option.value
      }
    }, null), api_static_part(1, null, api_dynamic_text(option.label))]) : null];
  }))])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-132gku5be29";
tmpl.legacyStylesheetToken = "undefined-_locationFilter";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
